import React from "react";
import { useIsReadOnlyManager, isBlockedForReadOnlyManager } from "@/shared/readOnlyManager";
import ParticipantTopbar from "./topbar/Participant";
import ManagerTopbar from "./topbar/Manager";
import { ManagerFooter, ParticipantFooter } from "./footer";
import { Navigate, Outlet, useLocation } from "react-router-dom";

export const ParticipantLayout = () => (
  <div className="participant-layout">
    <main className="participant">
      <ParticipantTopbar />
      <Outlet />
    </main>
    <ParticipantFooter />
  </div>
);

export const ManagerLayout = () => {
  const { pathname } = useLocation();
  const readOnly = useIsReadOnlyManager();

  if (readOnly && isBlockedForReadOnlyManager(pathname)) {
    return <Navigate to="/manager/home" replace />;
  }

  return (
    <>
      <main className="manager">
        <ManagerTopbar />
        <Outlet />
      </main>
      <ManagerFooter />
    </>
  );
};
